import { Config } from 'configs';
import { isCompanyAllowedForV2 } from './apiActionChooser';

export function formFileUrlFromDbFile(dbFile, getOriginal) {
  if (!dbFile) {
    return null;
  }

  const v2Enalbed = isCompanyAllowedForV2();
  const domain = v2Enalbed
    ? 'https://d2o01n7jpqohft.cloudfront.net'
    : `https://cm-${Config.CODEMASH.FILE_ACCOUNT_ID}.s3.eu-central-1.amazonaws.com`;

  if (!v2Enalbed && dbFile.optimizations && dbFile.optimizations.length > 0 && !getOriginal) {
    const firstOptimization = dbFile.optimizations[0];

    return `${domain}/${firstOptimization.directory}/${firstOptimization.fileName}`;
  }

  return `${domain}/${dbFile.directory}/${dbFile.fileName}`;
}

export function formFileUrlFromFileArray(fileArray, getOriginal) {
  if (typeof fileArray === 'string') {
    return fileArray;
  }

  if (!fileArray || fileArray.length === 0) {
    return null;
  }

  const dbFile = fileArray[0];

  return formFileUrlFromDbFile(dbFile, getOriginal);
}

export function getFileSizeFromBase64(base64) {
  if (!base64) {
    return 0;
  }

  const baseLength = base64.length;
  const numberOfPaddingCharacters = base64[baseLength - 2] === '=' ? 2 : 1;

  const bytesSize = 3 * (baseLength / 4) - numberOfPaddingCharacters;

  return bytesSize;
}

export function convertBytesToMb(bytes) {
  return bytes / (1024 * 1024);
}

export function formFileUrlFromFileArrayWithExternalResized(originalFileArray, resizedFileArray) {
  if (!originalFileArray || originalFileArray.length === 0) {
    return null;
  }

  if (!resizedFileArray || resizedFileArray.length === 0) {
    return formFileUrlFromFileArray(originalFileArray);
  }

  const resizedFile = resizedFileArray[0];
  const originalFile = originalFileArray[0];

  if (originalFile.fileName !== resizedFile.originalFileName) {
    return formFileUrlFromFileArray(originalFileArray);
  }

  return formFileUrlFromDbFile(resizedFile);
}
